import backArrow from "../../../assets/img/backArrow.png"
import { useEffect, useState, useContext } from "react";
import { GlobalContext } from 'GlobalContext';
import { message, Spin } from "antd";
import { get } from "utils/fetch";
import api from "api";

export function BasicInfo(props) {
    const { setManageRecordId, manageRecordId, setManageRecordTab, accessToken, globalId } = useContext(GlobalContext)
    const { setView } = props
    const [messageApi, contextHolder] = message.useMessage();
    const [assetBasicInfo, setAssetBasicInfo] = useState({})
    const [loading, setLoading] = useState(true)
    const [address1, setAddress1] = useState("")
    const [address2, setAddress2] = useState("")
    const [city, setCity] = useState("")
    const [county, setCounty] = useState("")
    const [state, setState] = useState("")
    const [zipCode, setZipCode] = useState("")
    const [owner, setOwner] = useState("")
    const [propertyType, setPropertyType] = useState("")
    const [projectStrategy, setProjectStrategy] = useState("")
    const [businessLine, setBusinessLine] = useState("")
    const [fund, setFund] = useState("")
    const [purchasePrice, setPurchasePrice] = useState(0)
    const [purchaseCloseDate, setPurchaseCloseDate] = useState("")
    const [occupancyStatus, setOccupancyStatus] = useState("")
    const [projectManager, setProjectManager] = useState("")
    const [targetExitDate, setTargetExitDate] = useState("")
    const [propertyNotes, setPropertyNotes] = useState("")

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchAssetBasicInfo(id) {
        // retrieve holding companies associate with property
        await get(api.asset.basicInfo(id), setAssetBasicInfo, (errors) =>
            errors.forEach(err => {
                displayErrorMessage(err.message);
            }), accessToken
        )
        setLoading(false)
    }
    console.log(assetBasicInfo)

    function restore() {
        setAddress1(assetBasicInfo === null || assetBasicInfo.address === null ? "" : assetBasicInfo.address)
        setAddress2(assetBasicInfo === null || assetBasicInfo.address2 === null ? "" : assetBasicInfo.address2)
        setCity(assetBasicInfo === null || assetBasicInfo.city === null ? "" : assetBasicInfo.city)
        setCounty(assetBasicInfo === null || assetBasicInfo.county === null ? "" : assetBasicInfo.county)
        setState(assetBasicInfo === null || assetBasicInfo.state === null ? "" : assetBasicInfo.state)
        setZipCode(assetBasicInfo === null || assetBasicInfo.zip === null ? "" : assetBasicInfo.zip)
        setOwner(assetBasicInfo === null || assetBasicInfo.owner === null ? "" : assetBasicInfo.owner)
        setPropertyType(assetBasicInfo === null || assetBasicInfo.property_type === null ? "" : assetBasicInfo.property_type)
        setProjectStrategy(assetBasicInfo === null || assetBasicInfo.project_strategy === null ? "" : assetBasicInfo.project_strategy)
        setBusinessLine(assetBasicInfo === null || assetBasicInfo.business_line === null ? "" : assetBasicInfo.business_line)
        setFund(assetBasicInfo === null || assetBasicInfo.fund === null ? "" : assetBasicInfo.fund)
        setPurchasePrice(assetBasicInfo === null || assetBasicInfo.purchase_price === null ? 0 : assetBasicInfo.purchase_price)
        setPurchaseCloseDate(assetBasicInfo === null || assetBasicInfo.purchase_close_date === null ? "" : assetBasicInfo.purchase_close_date)
        setOccupancyStatus(assetBasicInfo === null || assetBasicInfo.occupancy_status === null ? "" : assetBasicInfo.occupancy_status)
        setProjectManager(assetBasicInfo === null || assetBasicInfo.project_manager === null ? "" : assetBasicInfo.project_manager)
        setTargetExitDate(assetBasicInfo === null || assetBasicInfo.target_exit_date === null ? "" : assetBasicInfo.target_exit_date)
        setPropertyNotes(assetBasicInfo === null || assetBasicInfo.property_notes === null ? "" : assetBasicInfo.property_notes)
    }

    useEffect(() => {
        restore()
    }, [assetBasicInfo])

    useEffect(() => {
        fetchAssetBasicInfo(manageRecordId)
    }, [manageRecordId])

    return <>
        <div style={{ margin: "20px", display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
            <img style={{ width: "15px", height: "20px", cursor: "pointer" }}
                src={backArrow}
                onClick={() => setView("main")}
            ></img>
            {loading && <div style={{ marginTop: "30px", textAlign: "center" }}><Spin /></div>}
            {!loading && <div>
                {assetBasicInfo.address}
            </div>}
        </div>
    </>
}